export const UserDirectory = [
  {
    path: '/appusers/:app_module_id',
    name: 'appusers.index',
    component: () => import('@/pages/UserDirectory/UserDirectoryModule')
  },
]
